































































































































































































import { Component, Vue } from "vue-property-decorator";
import { BIcon, BIconBoxArrowRight, ListGroupPlugin } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    BIcon,
    BIconBoxArrowRight,
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class CVTools extends Vue {
  protected nxtprevCVTools = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail2.png",
    NextImage: "/thumbnail4.png",
    PrevLink: "/CV/Astuces",
    NextLink: "/CV/Exemples",
  };
}
